// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d55a232d","77":"5d22f889","239":"d56abeb6","488":"f3b92b2f","863":"c04c5321","997":"61bda73e"}[chunkId] + ".chunk.js";
};